import Vue from 'vue'
import VueRouter from 'vue-router'
import Intro from '../views/IntroPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Intro
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutPage.vue')
  },
  {
    path: '/intro',
    name: 'Intro',
    component: () => import(/* webpackChunkName: "about" */ '../views/IntroPage.vue'),
    props: true
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import(/* webpackChunkName: "about" */ '../views/SettingsPage.vue'),
    props: true
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginPage.vue'),
    props: true
  },
  {
    path: '/story/:episode/:chapter/:story',
    name: 'Story',
    component: () => import(/* webpackChunkName: "about" */ '../views/StoryViewer.vue'),
    meta: {
      title: 'Story - TPFLA'
    },
    props: true
  },
  {
    path: '/contents',
    name: 'Contents',
    component: () => import(/* webpackChunkName: "about" */ '../components/ContentsComp.vue'),
    meta: {
      title: 'Episodes - TPFLA'
    },
    props: true
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'These Pages Fall Like Ash'
  next()
}
)
// If no user ID in local storage, force login
/* router.beforeEach((to, from, next) => {
  if (to.name !== 'Login' && !localStorage.getItem('user')) {
    next({ name: 'Login' })
  } else {
    next()
  }
}) */

export default router
